import { Injectable } from "@angular/core";
import * as moment from "moment-timezone";

@Injectable({
  providedIn: "root",
})
export class LocaleService {
  constructor() {}

  setDefaultTimezone() {
    moment.tz.setDefault("Etc/UTC");
  }
}
